import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-received-template',
  templateUrl: './payment-received-template.component.html',
})
export class PaymentReceivedTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
